/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Moderate_HideInputs */



/**
* | output |
* | --- |
* | "Hide link" |
*
* @param {Community_Moderate_HideInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_moderate_hide = /** @type {((inputs?: Community_Moderate_HideInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Moderate_HideInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Masquer le lien")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ocultar enlace")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ocultar link")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nascondi link")
	return /** @type {LocalizedString} */ ("Hide link")
});